import { render, staticRenderFns } from "./TipsFb.vue?vue&type=template&id=4bdade93&scoped=true&"
import script from "./TipsFb.vue?vue&type=script&lang=js&"
export * from "./TipsFb.vue?vue&type=script&lang=js&"
import style0 from "./TipsFb.vue?vue&type=style&index=0&id=4bdade93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdade93",
  null
  
)

component.options.__file = "TipsFb.vue"
export default component.exports